import { Grid, Stack, StackProps } from "@mui/material";
import { Product, Row, TextMd, ViewAllText } from "Components";
import { SEARCH_PARAM_VALUES, SEARCH_PARAMS } from "constants/routes";
import useBreakpoints from "hooks/useBreakpoint";
import useGetData from "hooks/useGetData";
import useUpdateSearchParams from "hooks/useUpdateSearchParams";
import { useMemo } from "react";
import { useIntl } from "react-intl";
import { apiGetProductsBySearch } from "services/api/item";
import { ProductType } from "types";

type Props = {
  supplierId?: string;
};

const ProductsFromSupplier = ({ supplierId, ...rest }: Props & StackProps) => {
  const t = useIntl();
  const { isMobile } = useBreakpoints();
  const updateSearchParams = useUpdateSearchParams();
  const { isLoading, data } = useGetData({
    promise: () =>
      supplierId
        ? apiGetProductsBySearch({
            farm_id: supplierId,
            limit: isMobile ? 4 : 12,
            offset: 0,
          })
        : null,
    deps: [supplierId],
  });
  const products: ProductType[] = useMemo(
    () => data?.data?.items || [],
    [data?.data]
  );

  const onClickViewAll = () => {
    updateSearchParams({
      [SEARCH_PARAMS.tab]: SEARCH_PARAM_VALUES.tabProduct,
    });
    window.scrollTo(0, 0);
  };

  if (!isLoading && products.length < 1) return null;

  return (
    <Stack spacing={2} {...rest}>
      <Row justifyContent="space-between">
        <TextMd component="h2">
          {t.formatMessage({ id: "supplier_products" })}
        </TextMd>
        <ViewAllText onClick={onClickViewAll} />
      </Row>

      <div>
        <Grid container spacing={1}>
          {products.map((product, id) => (
            <Grid item xs={6} md={3} key={id}>
              <Product product={product} />
            </Grid>
          ))}
        </Grid>
      </div>
    </Stack>
  );
};

export default ProductsFromSupplier;
